export const SELECTED_DAY_OPTIONS = [
  { id: 2, label: '月曜日', order: 1 },
  { id: 3, label: '火曜日', order: 2 },
  { id: 4, label: '水曜日', order: 3 },
  { id: 5, label: '木曜日', order: 4 },
  { id: 6, label: '金曜日', order: 5 },
  { id: 7, label: '土曜日', order: 6 },
  { id: 1, label: '日曜日', order: 7 },
]

export const SELECTED_DATE_OPTIONS = [...Array(31)].map((m, idx) => {
  return { id: idx + 1, label: `${idx + 1}日`, order: idx + 1 }
})
